import i18n, { InitOptions } from 'i18next'
import detector from 'i18next-browser-languagedetector'
import enFrontend from 'i18n/locale/en/en.json'

import { withTolgee, Tolgee, I18nextPlugin, TolgeeOptions } from '@tolgee/i18next'
import { BackendFetch } from '@tolgee/react'
import { initReactI18next } from 'react-i18next'

export const supportedLanguages = [
  {
    flag: 'gb wls',
    code: 'cy',
    language: 'Cymraeg',
  },
  {
    flag: 'dk',
    code: 'da',
    language: 'Dansk',
  },
  {
    flag: 'de',
    code: 'de',
    language: 'Deutsch',
  },
  {
    flag: 'gb',
    code: 'en',
    language: 'English',
  },
  {
    flag: 'es',
    code: 'es',
    language: 'Español',
  },
  {
    flag: '',
    code: 'eu',
    language: 'Euskara',
  },
  {
    flag: 'fi',
    code: 'fi',
    language: 'Suomi',
  },
  {
    flag: 'fr',
    code: 'fr',
    language: 'Français',
  },
  {
    flag: 'it',
    code: 'it',
    language: 'Italiana',
  },
  {
    flag: 'kr',
    code: 'ko',
    language: '한국어',
  },
  {
    flag: 'nl',
    code: 'nl',
    language: 'Nederlands',
  },
  {
    flag: 'pl',
    code: 'pl',
    language: 'Polski',
  },
  {
    flag: 'br',
    code: 'pt-BR',
    language: 'Português',
  },
  {
    flag: 'ru',
    code: 'ru',
    language: 'Pусский',
  },
  {
    flag: 'se',
    code: 'sv',
    language: 'Svenska',
  },
  {
    flag: 'tr',
    code: 'tr',
    language: 'Türkçe',
  },
  {
    flag: 'cn',
    code: 'zh-Hans',
    language: '简体中文',
  },
  {
    flag: 'cn',
    code: 'zh-Hant',
    language: '繁體中文',
  },
  {
    flag: 'jp',
    code: 'ja',
    language: '日本語',
  },
]

let tolgee

if (process.env.NODE_ENV === 'test') {
  // Simple mock for testing
  tolgee = {
    addPlugin: () => tolgee,
    init: () => Promise.resolve(),
    run: () => Promise.resolve(),
  }
} else {
  tolgee = Tolgee()
    .use(I18nextPlugin())
    .use(BackendFetch({ prefix: 'https://cdn-translations.developers.lifefitness.com/f2ec33417f8beb4f8444a9f3fa6a359d' }))
    .init({
      // for development
      apiUrl: 'https://tolgee-yjuvivvkga-uc.a.run.app/',
      apiKey: 'tgpak_gnpwqmdmnbtgwmzwovswkylworsdo4rxnnutkmdum5wg6',
      ns: ['Frontend', 'Exercises', 'Workouts', 'Zones'],
      defaultNs: 'Frontend',
      fallbackNs: ['Frontend', 'Exercises', 'Workouts', 'Zones'],
      defaultLanguage: 'en',
      fallbackLanguage: 'en',
      supportedLanguages: ['en', 'es', 'eu', 'fi', 'ko', 'cy', 'da', 'de', 'fr', 'it', 'pt-BR', 'ja', 'sv', 'nl', 'pl', 'ru', 'tr', 'zh-Hans', 'zh-Hant'],
    } as TolgeeOptions)
}

let i18nInstance

if (process.env.NODE_ENV === 'test') {
  i18nInstance = i18n.use(detector)
  if (initReactI18next) {
    i18nInstance.use(initReactI18next)
  }
} else {
  i18nInstance = withTolgee(i18n, tolgee)
    .use(detector)
  if (initReactI18next) {
    i18nInstance.use(initReactI18next) // passes i18n down to react-i18next
  }
}

const initOptions = {
  load: 'currentOnly',
  ns: ['Frontend', 'Exercises', 'Workouts', 'Zones'],
  defaultNS: 'Frontend',
  defaultLanguage: 'en',
  fallbackLng: 'en',
  supportedLngs: ['en', 'es', 'eu', 'fi', 'ko', 'cy', 'da', 'de', 'fr', 'it', 'pt-BR', 'ja', 'sv', 'nl', 'pl', 'ru', 'tr', 'zh-Hans', 'zh-Hant'],
  keySeparator: false, // we do not use keys in form messages.welcome
  interpolation: {
    escapeValue: false, // react already safes from xss
  },
} as InitOptions

// Bundle the local English copy as an offline backup so keys still resolve to
// readable text when Tolgee/CDN translations haven't loaded yet or are missing.
// `partialBundledLanguages` keeps Tolgee as the source of truth — live values
// are merged on top of these defaults. Skipped under test (i18n is mocked there).
if (process.env.NODE_ENV !== 'test') {
  initOptions.resources = { en: { Frontend: enFrontend } }
  initOptions.partialBundledLanguages = true
}

i18nInstance.init(initOptions)

export default tolgee
